import { render } from "./infoExclamationMarkNoText.vue?vue&type=template&id=0ad6921c"
import script from "./infoExclamationMarkNoText.vue?vue&type=script&lang=js"
export * from "./infoExclamationMarkNoText.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__